"use client"
// 渐变 CTA 横幅：自 /solutions 页的 CTA 段抽出，首页与运营方案页共用
import React from 'react'
import { BlurFade } from './BlurFade'
import { cn } from '@/lib/utils'

export interface CtaBannerProps {
    title: string
    button: string
    href: string
    className?: string
}

export default function CtaBanner({ title, button, href, className }: CtaBannerProps) {
    return (
        // 外框透明：由所在页面决定底色（首页白 / solutions 深底 slate-950），避免深色页面上出现白带
        <section className={cn('pb-24', className)}>
            <div className="max-w-7xl mx-auto px-4 md:px-8">
                <BlurFade delay={0.05} inView>
                    <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-indigo-600 via-fuchsia-600 to-indigo-600 bg-[length:200%_auto] p-10 md:p-14 text-center shadow-2xl shadow-indigo-600/30">
                        <h2 className="text-2xl md:text-3xl font-black text-white">{title}</h2>
                        <a href={href}
                            className="mt-6 inline-block rounded-full bg-white px-8 py-3 text-sm font-bold text-indigo-700 transition-all duration-300 hover:scale-105 hover:shadow-xl">
                            {button}
                        </a>
                    </div>
                </BlurFade>
            </div>
        </section>
    )
}
